import { updateGeo } from 'shared/slices/jsonQuery';
import { TThunkAction } from 'shared/types/redux';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { addPolygonToJsonQuery } from 'shared/utils/jsonQuery';
import { IJsonQueryPolygon } from '../../../../packages/api-models/common/json_query';
import { updateTags } from 'shared/thunks/tags';
import { applyFilters } from 'shared/thunks/filters';
import { selectSearchMetaData } from 'shared/selectors/searchMeta';
import { updateSearchMeta } from 'shared/thunks/searchMeta';

export const selectPolygon =
  (polygon: IJsonQueryPolygon): TThunkAction =>
  async (dispatch, getState) => {
    const searchMeta = selectSearchMetaData(getState());

    if (!searchMeta) {
      await dispatch(updateSearchMeta());
    }

    const state = getState();
    const jsonQuery = selectJsonQuery(state);

    const newGeo = addPolygonToJsonQuery(jsonQuery, polygon);

    dispatch(updateGeo(newGeo));
    dispatch(updateTags());
    dispatch(applyFilters());
  };
